import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Sidebar navigation column: groups of nav items with the design's padding
 * and group spacing. The surrounding shell (rail width, `bg-zinc-975`
 * surface, org switcher, user footer) is composed at app level.
 *
 *   <vx-sidebar-nav>
 *     <vx-sidebar-nav-group>
 *       <vx-sidebar-nav-item link="/dashboard" icon="squares-four">…
 *     </vx-sidebar-nav-group>
 *     <vx-sidebar-nav-group>…</vx-sidebar-nav-group>
 *   </vx-sidebar-nav>
 *
 * Note: the active-item indicator anchors to this component's horizontal
 * padding (`px-3`) to sit flush with the sidebar edge.
 */
@Component({
  selector: 'vx-sidebar-nav',
  templateUrl: './sidebar-nav.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col gap-4 px-3 pt-2 pb-3 font-brand',
    role: 'navigation',
  },
})
export class VxSidebarNavComponent {}
